module.exports = "https://websites.getjusto.com/_next/static/images/addToAppleWallet-35c5d1f1a4b505fa475bf03e6785a7c0.svg";